import { getUnsupportedDecorationToTiptap, markConverters } from "./mark-converters";
const DECORATIONS_TO_MARKS_BY_TYPE = Object.fromEntries(
  [...markConverters].reverse().flatMap((converter) => converter.toTiptap.types.map((type) => [type, converter.toTiptap]))
);
const getDecorationToMarkConverter = (decoration) => DECORATIONS_TO_MARKS_BY_TYPE[decoration.type] || getUnsupportedDecorationToTiptap(decoration);
const decorationsToMarks = (decorations) => decorations.flatMap(
  (decoration) => getDecorationToMarkConverter(decoration).convert(decoration)
);
export {
  decorationsToMarks
};
//# sourceMappingURL=decorations-to-marks.js.map
